import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

export const ArrowBtn = ({ changeQty, isPlus }) => (
  <button type="button" className="card-qty__btn" onClick={changeQty}>
    {isPlus
      ? (<PesIcon class="card-qty__btn-icon" size={pesIconSizes.NANO}>
          electricity_polarity_positive_plus
        </PesIcon>)
      : (<PesIcon class="card-qty__btn-icon" size={pesIconSizes.NANO}>
          electricity_polarity_negative_minus
        </PesIcon>)}
  </button>
);

ArrowBtn.propTypes = {
  changeQty: propTypes.func.isRequired,
  isPlus: propTypes.bool.isRequired
};
